import * as actions from "./actionTypes";

export type Payload<T> = { payload: T };

export function beginAjaxCall(payload: string) {
    return {
        type: actions.BEGIN_AJAX_CALL,
        payload
    };
}

export function ajaxCallError() {
    return { type: actions.AJAX_CALL_ERROR };
}
